import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/ScrollToTopButton';
import Home from './pages/Home';
import About from './pages/About';
import Developments from './pages/Developments';
import CustomerCare from './pages/CustomerCare';
import Contact from './pages/Contact';
import logo from './assets/logo.png';


function App() {
  useEffect(() => {
    // Canvas ile yuvarlak favicon oluştur
    const createRoundFavicon = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const size = 64; // Daha büyük boyut
      
      canvas.width = size;
      canvas.height = size;
      
      if (ctx) {
        // Şeffaf arka plan (arka plan rengi yok)
        ctx.clearRect(0, 0, size, size);
        
        // Logo resmini yükle ve yuvarlak içine yerleştir
        const img = new Image();
        img.onload = () => {
          // Yuvarlak clipping path
          ctx.save();
          ctx.beginPath();
          ctx.arc(size / 2, size / 2, size / 2, 0, 2 * Math.PI);
          ctx.clip();
          
          // Logo'yu merkeze yerleştir ve daha büyük yap
          const logoSize = size * 1.85; // %95 büyüklük (daha büyük)
          const x = (size - logoSize) / 2 - 3; // 3 piksel sola kaydır
          const y = (size - logoSize) / 2;
          ctx.drawImage(img, x, y, logoSize, logoSize);
          
          ctx.restore();
          
          // Canvas'ı favicon olarak ayarla
          const dataURL = canvas.toDataURL('image/png');
          updateFavicon(dataURL);
        };
        img.src = logo;
      }
    };
    
    const updateFavicon = (dataURL: string) => {
      // Mevcut favicon linklerini kaldır
      const existingLinks = document.querySelectorAll("link[rel*='icon']");
      existingLinks.forEach(link => link.remove());
      
      // Yeni favicon linki oluştur
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.type = 'image/png';
      newLink.href = dataURL;
      // sizes özelliğini setAttribute ile ayarla
      newLink.setAttribute('sizes', '64x64');
      
      document.head.appendChild(newLink);
    };
    
    createRoundFavicon();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/developments" element={<Developments />} />
            <Route path="/customer-care" element={<CustomerCare />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
        <ScrollToTopButton />
      </div>
    </Router>
  );
}

export default App;
